import { ExperienceGPTAnswer, UnavailableExperienceData } from './types';
import { ExperienceJsonLDUtil } from 'shared/models/experience/json-ld-util';

export const ExperienceUtil = {
  isExperienceDataAvailable: (input: ExperienceGPTAnswer | UnavailableExperienceData): input is ExperienceGPTAnswer => {
    return !('unavailableReason' in input);
  },

  JsonLD: ExperienceJsonLDUtil,
};
